const URLS = {
    SEARCH_REQUEST: '/v1/search/suggestions/',
    SEARCH_LOGGER: '/v1/search/logger/',
    SEARCH_RESULTS: '/v1/search/results',
};

export { URLS };
//# sourceMappingURL=urls.js.map
